export default function (props) {
  return (
    <svg width="126px" height="126px" viewBox="0 0 126 126" {...props}>
        <g id="arrow" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <polygon id="Triangle" fill="currentColor" transform="translate(68.000000, 63.000000) rotate(90.000000) translate(-68.000000, -63.000000) " points="68 44 102 82 34 82"></polygon>
        </g>
    </svg>
  )
}